/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalReauthSubmissionStatus = {
    NotStarted: 'not_started',
    Incomplete: 'incomplete',
    Submitted: 'submitted',
    Pending: 'pending',
    Approved: 'approved',
    Denied: 'denied',
    Cancelled: 'cancelled',
    Appeal: 'appeal',
    PeerToPeer: 'peer_to_peer',
    PartialApproval: 'partial_approval',
    NomncIssued: 'nomnc_issued',
    NomncAppealed: 'nomnc_appealed',
} as const;
export type PalReauthSubmissionStatus = typeof PalReauthSubmissionStatus[keyof typeof PalReauthSubmissionStatus];


export function instanceOfPalReauthSubmissionStatus(value: any): boolean {
    for (const key in PalReauthSubmissionStatus) {
        if (Object.prototype.hasOwnProperty.call(PalReauthSubmissionStatus, key)) {
            if (PalReauthSubmissionStatus[key as keyof typeof PalReauthSubmissionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PalReauthSubmissionStatusFromJSON(json: any): PalReauthSubmissionStatus {
    return PalReauthSubmissionStatusFromJSONTyped(json, false);
}

export function PalReauthSubmissionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionStatus {
    return json as PalReauthSubmissionStatus;
}

export function PalReauthSubmissionStatusToJSON(value?: PalReauthSubmissionStatus | null): any {
    return value as any;
}

export function PalReauthSubmissionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): PalReauthSubmissionStatus {
    return value as PalReauthSubmissionStatus;
}

